import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TopBar,
  ActionList,
  Icon,
  Button,
  VisuallyHidden,
  Text,
} from '@shopify/polaris';
import { HorizontalDotsMinor } from '@shopify/polaris-icons';

const LandingNav = ({ currentPath, onNavClick }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Handle responsive view
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Navigation items
  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'AI Engines', path: '/ai-engines' },
    { label: 'Templates', path: '/templates' },
    { label: 'How it Works', path: '/how-it-works' },
    { label: 'Pricing', path: '/pricing' },
  ];

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  
  const handleNavigationClick = (path) => {
    setIsMenuOpen(false);
    // Always use direct navigation to ensure consistent behavior
    navigate(path);
  };

  const handleLoginClick = () => {
    navigate('/auth');
  };

  const handleRegisterClick = () => {
    navigate('/register');
  };

  

  return (
    <div style={{ marginBottom: '20px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)', position: 'relative', zIndex: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', backgroundColor: 'white' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleNavigationClick('/')}>
            <img src="/logo.png" alt="Editify" style={{ height: '36px', marginRight: '12px' }} />
            <Text variant="headingMd" as="h1" fontWeight="bold">Editify</Text>
          </div>
          
          {!isMobileView && (
            <div style={{ marginLeft: '40px', display: 'flex', gap: '24px' }}>
              {navItems.map((item) => (
                <div 
                  key={item.path} 
                  onClick={() => handleNavigationClick(item.path)}
                  style={{ 
                    cursor: 'pointer',
                    padding: '10px 16px',
                    borderRadius: '4px',
                    backgroundColor: currentPath === item.path ? 'rgba(0, 128, 96, 0.1)' : 'transparent',
                    color: currentPath === item.path ? '#008060' : 'inherit',
                    fontWeight: currentPath === item.path ? '600' : '400',
                    fontSize: '16px',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (currentPath !== item.path) {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 128, 96, 0.05)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (currentPath !== item.path) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  {item.label}
                </div>
              ))}
            </div>
          )}
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isMobileView ? (
            <Button onClick={toggleMenu} accessibilityLabel="Toggle menu">
              <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 4h14v2H3V4zm0 5h14v2H3V9zm0 5h14v2H3v-2z" fill="currentColor"/>
              </svg>
            </Button>
          ) : (
            <div style={{ display: 'flex', gap: '12px' }}>
              <Button size="medium" onClick={handleLoginClick} style={{ minWidth: '100px', padding: '6px 16px', fontSize: '16px' }}>Log in</Button>
              <Button size="medium" primary onClick={handleRegisterClick} style={{ minWidth: '100px', padding: '6px 16px', fontSize: '16px' }}>Sign up</Button>
            </div>
          )}
        </div>
      </div>
      
      {/* Mobile menu overlay */}
      {isMenuOpen && isMobileView && (
        <div>
          <div
            style={{
              position: 'fixed',
              top: '0',
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 400,
            }}
            onClick={toggleMenu}
          />
          
          <div style={{
            position: 'absolute',
            top: '70px',
            right: '20px',
            width: '100%',
            maxWidth: '300px',
            backgroundColor: 'white',
            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
            zIndex: 500,
            borderRadius: '4px',
          }}>
            <ActionList
              actionRole="menuitem"
              items={[
                ...navItems.map((item) => ({
                  content: item.label,
                  onAction: () => handleNavigationClick(item.path),
                  active: currentPath === item.path
                })),
                {
                  content: 'Log in',
                  onAction: handleLoginClick
                },
                {
                  content: 'Sign up',
                  onAction: handleRegisterClick
                }
              ]}
            />
          </div>
        </div>
      )}

    </div>
  );
};

export default LandingNav;
